import React from 'react';
import FAQPricing from './FAQPricing';
import '../pages/style/Pricing.css';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook

function PricingDetail({
  isAnnual,
  toggleBilling,
  getDiscountedPrice,
  stripeLoading,
  stripeError,
  handleOneTimeClick,
  handleStandardClick,
  handleProfessionalClick,
}) {
  const { t } = useTranslation(); // Initialize the translation function

  // 🔥 Code promo pour le ruban (laisser "" pour désactiver)
  const promoCode = "BLACKFRIDAY50"; // ex: "PROMO10" ou "" si pas de promo

  return (
    <div className="pricing-page">
      <h2 className="pricing-title">{t('pricingPage.title')}</h2>
      <div className="toggle-row">
        <span className={!isAnnual ? 'active-toggle' : ''}>{t('pricingPage.monthlyPlans')}</span>
        <div className={`toggle-button ${isAnnual ? 'active' : ''}`} onClick={toggleBilling}>
          <div className="toggle-indicator" />
        </div>
        <span className={isAnnual ? 'active-toggle annual-discount' : 'annual-discount'}>
          {t('pricingPage.annualPlans')} <strong>{t('pricingPage.discount')}</strong>
        </span>
      </div>

      <div className="plans">
        {/* Basic Plan */}
        <div className="plan-card">
          {promoCode && (
            <div className="promo-ribbon-wrapper">
              <div className="promo-ribbon">{promoCode}</div>
            </div>
          )}

          <h3>{t('pricingPage.basicPlan.title')}</h3>
          <p className="subtitle">{t('pricingPage.basicPlan.subtitle')}</p>
          <h2>{t('pricingPage.basicPlan.price')}</h2>
          <button className="btn" disabled>
            {t('pricingPage.getAccessNow')}
          </button>
          <ul>
            <li>✓ {t('pricingPage.basicPlan.features.events')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.unlimitedFeatures')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.imagesComments')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.postLivePhoto')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.postLiveComments')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.retention')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.highQualityImages')}</li>
            <li>✓ {t('pricingPage.basicPlan.features.watermark')}</li>
          </ul>
        </div>

        {/* One Time Plan */}
        <div className="plan-card">
          {promoCode && (
            <div className="promo-ribbon-wrapper">
              <div className="promo-ribbon">{promoCode}</div>
            </div>
          )}

          <h3>{t('pricingPage.oneTimePlan.title')}</h3>
          <p className="subtitle">{t('pricingPage.oneTimePlan.subtitle')}</p>
          <h2>{getDiscountedPrice("19.99", { oneTime: true })}</h2>
          <button
            className="btn"
            onClick={handleOneTimeClick}
            disabled={stripeLoading || isAnnual}
          >
            {stripeLoading ? t('pricingPage.loading') : t('pricingPage.getAccessNow')}
          </button>
          <ul>
            <li>✓ {t('pricingPage.oneTimePlan.features.events')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.limitedFeatures')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.imagesComments')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.postLivePhoto')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.postLiveComments')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.retention')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.highQualityImages')}</li>
            <li>✓ {t('pricingPage.oneTimePlan.features.aiModeration')}</li>
            <li>{t('pricingPage.oneTimePlan.features.noWatermark')}</li>
          </ul>
        </div>

        {/* Standard Plan */}
        <div className="plan-card pro">
          {promoCode && (
            <div className="promo-ribbon-wrapper">
              <div className="promo-ribbon">{promoCode}</div>
            </div>
          )}
          <div className="tag">{t('pricingPage.standardPlan.tag')}</div>

          <h3>{t('pricingPage.standardPlan.title')}</h3>
          <p className="subtitle">{t('pricingPage.standardPlan.subtitle')}</p>
          <h2>{getDiscountedPrice(29.99)}</h2>
          <button
            className="btn btn-yellow"
            onClick={handleStandardClick}
            disabled={stripeLoading}
          >
            {stripeLoading ? t('pricingPage.loading') : t('pricingPage.getAccessNow')}
          </button>
          <ul>
            <li>✓ {t('pricingPage.standardPlan.features.events')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.limitedFeatures')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.imagesComments')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.postLivePhoto')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.postLiveComments')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.retention')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.highQualityImages')}</li>
            <li>✓ {t('pricingPage.standardPlan.features.aiModeration')}</li>
            <li>{t('pricingPage.standardPlan.features.noWatermark')}</li>
          </ul>
        </div>

        {/* Professional Plan */}
        <div className="plan-card">
          {promoCode && (
            <div className="promo-ribbon-wrapper">
              <div className="promo-ribbon">{promoCode}</div>
            </div>
          )}

          <h3>{t('pricingPage.professionalPlan.title')}</h3>
          <p className="subtitle">{t('pricingPage.professionalPlan.subtitle')}</p>
          <h2>{getDiscountedPrice(149.99)}</h2>
          <button
            className="btn"
            onClick={handleProfessionalClick}
            disabled={stripeLoading}
          >
            {stripeLoading ? t('pricingPage.loading') : t('pricingPage.getAccessNow')}
          </button>
          <ul>
            <li>
              ✓ <span className="limited-tooltip-wrapper">
                <span className="limited-gold">{t('pricingPage.professionalPlan.features.unlimitedEvents').split(' ')[0]}</span>
                <span className="limited-tooltip">
                  {t('pricingPage.professionalPlan.features.unlimitedTooltip')}
                </span>
              </span> {t('pricingPage.professionalPlan.features.unlimitedEvents').split(' ')[1]}
            </li>
            <li>✓ {t('pricingPage.professionalPlan.features.unlimitedFeatures')}</li>
            <li>
              ✓ <span className="limited-tooltip-wrapper">
                <span className="limited-gold">{t('pricingPage.professionalPlan.features.unlimitedImages').split(' ')[0]}</span>
                <span className="limited-tooltip">
                  {t('pricingPage.professionalPlan.features.unlimitedTooltip')}
                </span>
              </span> {t('pricingPage.professionalPlan.features.unlimitedImages').split(' ')[1]} |&nbsp;
              <span className="limited-tooltip-wrapper">
                <span className="limited-gold">{t('pricingPage.professionalPlan.features.unlimitedComments').split(' ')[0]}</span>
                <span className="limited-tooltip">
                  {t('pricingPage.professionalPlan.features.unlimitedTooltip')}
                </span>
              </span> {t('pricingPage.professionalPlan.features.unlimitedComments').split(' ')[1]}
            </li>
            <li>✓ {t('pricingPage.professionalPlan.features.postLivePhoto')}</li>
            <li>✓ {t('pricingPage.professionalPlan.features.postLiveComments')}</li>
            <li>✓ {t('pricingPage.professionalPlan.features.retention')}</li>
            <li>✓ {t('pricingPage.professionalPlan.features.highQualityImages')}</li>
            <li>✓ {t('pricingPage.professionalPlan.features.aiModeration')}</li>
            <li>{t('pricingPage.professionalPlan.features.noWatermark')}</li>
          </ul>
        </div>
      </div>

      {/* Affiche une erreur Stripe éventuelle */}
      {stripeError && (
        <div className="error-message" style={{ color: 'red', margin: '1rem 0' }}>
          {stripeError}
        </div>
      )}

      <div className="pricing-disclaimer">
        <p>
          <strong>{t('pricingPage.disclaimer.pricesInEuro')}</strong> — {t('pricingPage.disclaimer.subjectTo')}{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer">{t('pricingPage.disclaimer.termsOfUse')}</a> &{' '}
          <a href="/fair-usage" target="_blank" rel="noopener noreferrer">{t('pricingPage.disclaimer.fairUsagePolicy')}</a>.
        </p>
      </div>
      <p className="footer-note">
        {t('pricingPage.footerNote')}
      </p>

      <div className="pricing-table-container">
        <table className="pricing-table">
          <thead>
            <tr>
              <th>{t('pricingPage.table.features')}</th>
              <th>{t('pricingPage.table.basic')}</th>
              <th>{t('pricingPage.table.oneTime')}</th>
              <th>{t('pricingPage.table.standard')}</th>
              <th>{t('pricingPage.table.professional')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('pricingPage.table.event')}</td>
              <td className="check">3</td>
              <td className="check">1</td>
              <td className="check">3</td>
              <td className="check">{t('pricingPage.table.unlimited')}</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.imagesComments')}</td>
              <td>5|5</td>
              <td>500|500</td>
              <td>1000|1000</td>
              <td>{t('pricingPage.table.unlimited')}</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.postLivePhotos')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.postLiveComments')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.eventRetention')}</td>
              <td className="check">5 {t('pricingPage.table.days')}</td>
              <td className="check">7 {t('pricingPage.table.days')}</td>
              <td className="check">1 {t('pricingPage.table.month')}</td>
              <td className="check">3 {t('pricingPage.table.month')}</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.watermark')}</td>
              <td className="check">✓</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.imageQuality')}</td>
              <td className="check">High</td>
              <td className="check">High</td>
              <td className="check">High</td>
              <td className="check">High</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.aiModeration')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.textColorModification')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.backgroundColorModification')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.fontModification')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.textSizeModification')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.backgroundTextModification')}</td>
              <td className="check">✓</td>
              <td></td>
              <td></td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.transitionAnimation')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.scanMeDelay')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td></td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.imageTextDelay')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td></td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.qrCodeDisplay')}</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
              <td className="check">✓</td>
            </tr>
            <tr>
              <td>{t('pricingPage.table.textBanner')}</td>
              <td></td>
              <td></td>
              <td></td>
              <td className="check">✓</td>
            </tr>
          </tbody>
        </table>
      </div>
      <FAQPricing />
    </div>
  );
}

export default PricingDetail;
